import { el, setChildren } from 'redom';

import { stringToSVG } from 'utilities';

import './index.scss';

import playIconString from 'assets/images/video-play-icon.svg?raw';
import pauseIconString from 'assets/images/video-pause-icon.svg?raw';

const pauseIcon = stringToSVG(pauseIconString);
const playIcon = stringToSVG(playIconString);

class PlayerControls {

  constructor(videoBuilder) {

    this.videoBuilder = videoBuilder;
    this.paused = false;

    this.playButton = el('button.video-builder-play-button', {
      class: 'video-builder-player-button',
      onclick: () => {
        this.play();
      }
    }, playIcon.cloneNode(true));
    this.pauseButton = el('button.video-builder-pause-button', {
      class: 'video-builder-player-button',
      onclick: () => {
        this.pause();
      }
    }, pauseIcon.cloneNode(true));

    this.el = el('.video-builder-player-controls', this.playButton);

  }

  play() {

    if (this.paused === true) {
      this.videoBuilder.resume();
    } else {
      this.videoBuilder.play();
    }

    setChildren(this.el, [this.pauseButton]);

  }

  pause() {

    this.paused = true;
    this.videoBuilder.pause();

    setChildren(this.el, [this.playButton]);

  }

  reset() {

    this.paused = false;
    setChildren(this.el, [this.playButton]);

  }

}

export default PlayerControls;